import { useContext } from 'react'
import { NotificationContext } from '../../contexts/notificationContext'

/**
 * Хук для использования контекста уведомлений
 * @returns Контекст уведомлений с данными и функциями управления
 * @throws Ошибка, если хук используется вне NotificationProvider
 */
export function useNotifications() {
  const context = useContext(NotificationContext)

  if (context === undefined) {
    throw new Error('useNotifications must be used within a NotificationProvider')
  }

  return context
}
